const url = '/service-start-date-options';
const Provider = 'ServiceStartDateOptions';
const dbModel = 'ServiceStartDateOptions';

export { url, Provider, dbModel };
